import {
  dailyServiceFrequencyColumns,
  dailyServiceFrequencyDefaultColumns,
  dailyServiceFrequencySpecificFilters,
  dailyServiceFrequencySummary,
} from '@cabgo/shared';
import type { ReportViewDefinition } from '../reportViewTypes';

export const dailyServiceFrequencyView: ReportViewDefinition = {
  key: 'daily_service_frequency',
  titleKey: 'dailyFrequencyTitle',
  descriptionKey: 'dailyFrequencyDescription',
  dateBasisKey: 'dailyFrequencyDateBasis',
  columns: dailyServiceFrequencyColumns,
  defaultColumns: dailyServiceFrequencyDefaultColumns,
  dateMode: 'range',
  supportsSearch: false,
  defaultSort: 'businessDate',
  sorts: ['businessDate'],
  filters: dailyServiceFrequencySpecificFilters.map((filter) => ({
    ...filter,
    labelKey: `dailyFrequencyFilter_${filter.id}`,
    ...(filter.id === 'serviceMode'
      ? {
          options: filter.values.map((value) => ({
            value,
            labelKey: `dailyFrequencyMode_${value}`,
          })),
        }
      : {}),
  })),
  valueLabels: {
    date_basis: { SERVICE_DATE: 'dailyFrequencyValue_serviceDate' },
  },
  summary: dailyServiceFrequencySummary,
  primarySummary: [
    'tripCount',
    'acceptedTripCount',
    'completedTripCount',
    'cancelledTripCount',
    'missedTripCount',
    'outstandingTotalSum',
  ],
  summaryGroups: [
    {
      labelKey: 'summaryGroupOverview',
      fields: [
        'totalRows',
        'tripCount',
        'acceptedTripCount',
        'completedTripCount',
        'cancelledTripCount',
        'missedTripCount',
      ],
    },
    {
      labelKey: 'summaryGroupFinance',
      fields: [
        'fareTotalSum',
        'billedTotalSum',
        'receivedTotalSum',
        'outstandingTotalSum',
        'freeTripCount',
        'financeReviewCount',
      ],
    },
    {
      labelKey: 'summaryGroupDispatch',
      fields: [
        'offersCount',
        'acceptedOfferCount',
        'rejectedOfferCount',
        'expiredOfferCount',
        'supersededOfferCount',
        'cancelledOfferCount',
        'pendingOfferCount',
      ],
    },
    {
      labelKey: 'summaryGroupCancellation',
      fields: [
        'cancelledByPassengerCount',
        'cancelledByAgentCount',
        'cancelledByOrgUserCount',
        'cancelledBySystemCount',
        'cancelledByOtherCount',
      ],
    },
    {
      labelKey: 'summaryGroupEvidence',
      fields: [
        'scheduledDateTripCount',
        'createdDateFallbackTripCount',
        'cancelledByUnknownCount',
        'missingFareCount',
        'withoutAcceptanceEvidenceTripCount',
        'completedStateWithoutEventTripCount',
        'cancelledStateWithoutEventTripCount',
      ],
    },
  ],
};
